// src/components/event/SmallPhotoArc.jsx
import React from 'react'
import { PHOTOS, BASE_PATH } from '../../data/eventPhotos'

const SmallPhotoArc = ({ currentIndex, onSelect }) => {
    const total = PHOTOS.length
    const offsets = [-2, -1, 0, 1, 2]

    return (
        <div className="mt-4 flex justify-center gap-2 sm:gap-3">
            {offsets.map((offset) => {
                const idx = (currentIndex + offset + total) % total
                const photo = PHOTOS[idx]
                const isCenter = offset === 0

                const rotate =
                    offset === 0 ? 0 : offset < 0 ? -7 * Math.abs(offset) : 7 * Math.abs(offset)
                const translateY = offset === 0 ? 0 : 6
                const scale = isCenter ? 1 : 0.9
                const opacity = isCenter ? 1 : 0.78

                return (
                    <button
                        key={`${photo.file}-${offset}`}
                        type="button"
                        onClick={() => onSelect(idx)}
                        className="relative h-16 w-20 overflow-hidden rounded-xl border border-white/15 bg-black/40 shadow-[0_14px_40px_rgba(0,0,0,0.9)] transition-all duration-300 sm:h-20 sm:w-28"
                        style={{
                            transform: `translateY(${translateY}px) rotate(${rotate}deg) scale(${scale})`,
                            opacity,
                        }}
                    >
                        <img
                            src={`${BASE_PATH}/${photo.file}`}
                            alt=""
                            className="h-full w-full object-cover"
                        />
                        {isCenter && (
                            <span className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent px-1.5 pb-0.5 pt-1 text-[0.6rem] text-center text-rose-100">
                now
              </span>
                        )}
                    </button>
                )
            })}
        </div>
    )
}

export default SmallPhotoArc
